module.exports = __webpack_public_path__ + "static/media/sofa.b0f80f81.png";